module.exports = __webpack_public_path__ + "static/img/empty-green.fd52149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-green.png
// module id = f2wu
// module chunks = 14